module.exports = __webpack_public_path__ + "static/media/ic_btn_link.c4fd48c6.svg";